import React from 'react';
import { Query } from '@apollo/client/react/components';
import { get } from 'lodash';

import RankIndexQuery from './RankIndexQueryContainer';

import CurrentRankingInfo from 'buyside/graphql/queries/CurrentRankingInfo';
import CurrentUserRankings from 'buyside/graphql/queries/CurrentUserRankings';

const RankingsIndexAreaQueriesContainer = ({ children, category, isPublic }) => {
  return (
    <Query query={CurrentRankingInfo} variables={{ category }}>
      {({ loading: rankingLoading, data: currentRankingData = {} }) => {
        return (
          <Query query={CurrentUserRankings} skip={isPublic}>
            {({ loading: currentUserLoading, data: currentUserData }) => {
              return (
                <RankIndexQuery category={category}>
                  {({ loading: ranksLoading, data: rankIndexData = {} }) => {
                    const currentRankingForCategory = currentRankingData.currentRankingForCategory;
                    const currentUser = isPublic ? null : get(currentUserData, ['currentUser']);

                    return children({
                      loading: currentUserLoading || ranksLoading || rankingLoading,
                      data: {
                        rankingDate: currentRankingForCategory
                          ? currentRankingForCategory.date
                          : null,
                        requiredSubmissionAmount: currentRankingForCategory
                          ? currentRankingForCategory.confidence
                          : null,
                        canViewIdeaFilterDetails:
                          !isPublic && Boolean(get(currentUser, ['canViewIdeaFilterDetails'])),
                        canViewUserDetails:
                          !isPublic && Boolean(get(currentUser, ['canViewUserDetails'])),
                        currentUserId: get(currentUser, ['id']),
                        ranks: rankIndexData ? rankIndexData.ranks : null,
                        hasNextPage: rankIndexData ? rankIndexData.hasNextPage : null,
                        fetchNextPage: rankIndexData ? rankIndexData.fetchNextPage : null
                      }
                    });
                  }}
                </RankIndexQuery>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

export default RankingsIndexAreaQueriesContainer;
